import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import styles from "./divider.css";

export const Divider = ({ container, full, ...rest }) => {
  const className = cn(
    !container && !full && styles.divider,
    container && styles.dividerContainer,
    full && styles.dividerFull,
    rest.className
  );

  return <hr {...rest} className={className} aria-hidden="true" />;
};

Divider.propTypes = {
  container: PropTypes.bool,
  full: PropTypes.bool,
};

Divider.defaultProps = {
  container: false,
  full: false,
};
